(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('[id^="instagram-feed-"]');

    sections.forEach(function(section) {
      const track = section.querySelector('.ig-feed__track');
      const cards = section.querySelectorAll('.ig-feed__card');
      const prevBtn = section.querySelector('.ig-feed__nav--prev');
      const nextBtn = section.querySelector('.ig-feed__nav--next');
      const dots = section.querySelectorAll('.ig-feed__dot');
      const dotsWrap = section.querySelector('.ig-feed__dots');
      const scrollSpeedSec = parseInt(track.dataset.scrollSpeed || '5', 10);

      if (cards.length === 0) return;

      let currentIndex = 0;
      let autoScrollTimer = null;
      let isDragging = false;
      let isSparse = false;
      let startX = 0;

      function getCardWidth() {
        var card = cards[0];
        var gap = parseInt(window.getComputedStyle(track).gap) || 16;
        return card.offsetWidth + gap;
      }

      function scrollToIndex(index) {
        if (isSparse) {
          currentIndex = 0;
          track.style.transform = 'none';
          return;
        }
        if (index < 0) index = 0;
        var maxVisible = Math.floor(track.parentElement.offsetWidth / getCardWidth());
        var maxIndex = Math.max(0, cards.length - maxVisible);
        if (index > maxIndex) index = 0;

        currentIndex = index;
        var offset = currentIndex * getCardWidth();
        track.style.transform = 'translateX(-' + offset + 'px)';

        dots.forEach(function(dot, i) {
          if (i === currentIndex) {
            dot.classList.add('ig-feed__dot--active');
            dot.setAttribute('aria-selected', 'true');
          } else {
            dot.classList.remove('ig-feed__dot--active');
            dot.setAttribute('aria-selected', 'false');
          }
        });
      }

      function startAutoScroll() {
        stopAutoScroll();
        if (isSparse) return;
        autoScrollTimer = setInterval(function() {
          scrollToIndex(currentIndex + 1);
        }, scrollSpeedSec * 1000);
      }

      function stopAutoScroll() {
        if (autoScrollTimer) { clearInterval(autoScrollTimer); autoScrollTimer = null; }
      }

      function updateSparseLayout() {
        var styles = window.getComputedStyle(track);
        var gap = parseInt(styles.gap, 10) || 16;
        var padding = (parseInt(styles.paddingLeft, 10) || 0) + (parseInt(styles.paddingRight, 10) || 0);
        var cardsWidth = (cards.length * cards[0].offsetWidth) + (Math.max(0, cards.length - 1) * gap);
        var availableWidth = track.clientWidth - padding;

        isSparse = cardsWidth <= availableWidth;
        track.classList.toggle('ig-feed__track--sparse', isSparse);
        if (prevBtn) prevBtn.style.display = isSparse ? 'none' : '';
        if (nextBtn) nextBtn.style.display = isSparse ? 'none' : '';
        if (dotsWrap) dotsWrap.style.display = isSparse ? 'none' : '';
        if (isSparse) {
          stopAutoScroll();
          scrollToIndex(0);
        }
      }

      updateSparseLayout();
      window.addEventListener('resize', updateSparseLayout);

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          scrollToIndex(currentIndex - 1); stopAutoScroll(); startAutoScroll();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          scrollToIndex(currentIndex + 1); stopAutoScroll(); startAutoScroll();
        });
      }
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          scrollToIndex(parseInt(dot.dataset.index, 10)); stopAutoScroll(); startAutoScroll();
        });
      });

      section.addEventListener('mouseenter', stopAutoScroll);
      section.addEventListener('mouseleave', startAutoScroll);

      // ── Drag detection (so a drag does not trigger the lightbox) ──
      var dragDist = 0;
      track.addEventListener('mousedown', function(e) {
        isDragging = true; startX = e.pageX; dragDist = 0;
        track.classList.add('is-dragging'); stopAutoScroll();
      });
      track.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        dragDist = Math.abs(e.pageX - startX);
      });
      function endDrag(e) {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('is-dragging');
        var diff = startX - (e.pageX || startX);
        if (Math.abs(diff) > 50) {
          if (diff > 0) scrollToIndex(currentIndex + 1); else scrollToIndex(currentIndex - 1);
        }
        startAutoScroll();
      }
      track.addEventListener('mouseup', endDrag);
      track.addEventListener('mouseleave', function() {
        if (isDragging) { isDragging = false; track.classList.remove('is-dragging'); }
      });

      var touchStartX = 0;
      track.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].pageX; stopAutoScroll();
      }, { passive: true });
      track.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].pageX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) scrollToIndex(currentIndex + 1); else scrollToIndex(currentIndex - 1);
        }
        startAutoScroll();
      }, { passive: true });

      section.setAttribute('tabindex', '0');
      section.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') { scrollToIndex(currentIndex - 1); stopAutoScroll(); startAutoScroll(); }
        else if (e.key === 'ArrowRight') { scrollToIndex(currentIndex + 1); stopAutoScroll(); startAutoScroll(); }
      });

      startAutoScroll();

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) startAutoScroll(); else stopAutoScroll();
        });
      }, { threshold: 0.3 });
      observer.observe(section);

      // ───────────────────────────────────────────────
      // Lightbox: image + native inline <video>, IG embed fallback
      // ───────────────────────────────────────────────
      var lightbox = section.querySelector('.ig-lightbox');
      if (!lightbox) return;

      var lbImage = lightbox.querySelector('.ig-lightbox__image');
      var lbVideo = lightbox.querySelector('.ig-lightbox__video');
      var lbEmbed = lightbox.querySelector('.ig-lightbox__embed');
      var lbContent = lightbox.querySelector('.ig-lightbox__content');
      var lbCaption = lightbox.querySelector('.ig-lightbox__caption-text');
      var lbAuthor = lightbox.querySelector('.ig-lightbox__author-line');
      var lbLink = lightbox.querySelector('.ig-lightbox__permalink');
      var lbClose = lightbox.querySelector('.ig-lightbox__close');
      var lbBackdrop = lightbox.querySelector('.ig-lightbox__backdrop');
      var lbPrev = lightbox.querySelector('.ig-lightbox__nav--prev');
      var lbNext = lightbox.querySelector('.ig-lightbox__nav--next');

      var lbIndex = 0;
      var postsData = [];
      cards.forEach(function(card, idx) {
        var dataEl = card.querySelector('.ig-feed__data');
        if (dataEl) {
          try { var d = JSON.parse(dataEl.textContent); d._index = idx; postsData.push(d); }
          catch (e) {}
        }
      });

      function loadInstagramEmbed() {
        if (window.instgrm && window.instgrm.Embeds) window.instgrm.Embeds.process();
        else if (!document.getElementById('ig-embed-script')) {
          var s = document.createElement('script');
          s.id = 'ig-embed-script'; s.async = true; s.src = 'https://www.instagram.com/embed.js';
          document.body.appendChild(s);
        }
      }
      function clearEmbed() { if (lbEmbed) { lbEmbed.innerHTML = ''; lbEmbed.style.display = 'none'; } }
      function clearVideo() {
        if (lbVideo) {
          try { lbVideo.pause(); } catch (e) {}
          lbVideo.onerror = null; lbVideo.removeAttribute('src');
          if (lbVideo.load) lbVideo.load();
          lbVideo.style.display = 'none';
        }
      }
      function showEmbed(post) {
        if (!lbEmbed) return;
        if (lbContent) lbContent.classList.add('ig-lightbox__content--video');
        clearVideo();
        lbImage.onerror = null;
        lbImage.style.display = 'none';
        lbEmbed.style.display = '';
        lbEmbed.innerHTML =
          '<blockquote class="instagram-media" data-instgrm-permalink="' +
          post.permalink + '?utm_source=ig_embed" data-instgrm-version="14" ' +
          'style="margin:0 auto;max-width:100%;width:100%;background:#fff;border-radius:8px;"></blockquote>';
        loadInstagramEmbed();
      }

      // Clean fallback for posts whose photo is gone (old community posts whose IG
      // CDN url expired and can't be re-hosted). Show an on-brand "view on
      // Instagram" panel next to the caption instead of an empty/black box.
      function showUnavailable(post) {
        if (lbContent) lbContent.classList.remove('ig-lightbox__content--video');
        clearVideo();
        lbImage.style.display = 'none';
        if (lbEmbed) {
          lbEmbed.style.display = '';
          lbEmbed.innerHTML =
            '<div class="ig-lightbox__unavailable">' +
            '<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="2" width="20" height="20" rx="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>' +
            '<p>This photo lives on Instagram</p>' +
            '<a href="' + (post.permalink || '#') + '" target="_blank" rel="noopener noreferrer">View on Instagram →</a>' +
            '</div>';
        }
      }

      function openLightbox(index) {
        if (index < 0 || index >= postsData.length) return;
        lbIndex = index;
        var post = postsData[index];
        var isVideo = post.mediaType === 'VIDEO' && post.permalink;

        if (isVideo && post.videoUrl && lbVideo) {
          if (lbContent) lbContent.classList.remove('ig-lightbox__content--video');
          clearEmbed();
          lbImage.style.display = 'none';
          lbVideo.style.display = '';
          lbVideo.poster = post.image || '';
          lbVideo.muted = true;
          lbVideo.src = post.videoUrl;
          lbVideo.onerror = function () { showEmbed(post); };
          var pp = lbVideo.play(); if (pp && pp.catch) pp.catch(function () {});
        } else if (isVideo) {
          lbImage.style.display = 'none';
          showEmbed(post);
        } else if (post.image) {
          if (lbContent) lbContent.classList.remove('ig-lightbox__content--video');
          clearVideo(); clearEmbed();
          lbImage.style.display = '';
          // If the image URL is dead (e.g. an old post's expired IG CDN link),
          // show a clean "view on Instagram" panel instead of a black box.
          lbImage.onerror = function () { lbImage.onerror = null; showUnavailable(post); };
          lbImage.src = post.image;
          lbImage.alt = post.caption || 'Instagram post';
        } else {
          clearEmbed();
          showUnavailable(post);
        }

        lbCaption.textContent = post.caption || '';
        lbAuthor.textContent = post.author ? ('@' + post.author) : '';
        lbLink.href = post.permalink || '#';

        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeLightbox() {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        clearVideo(); clearEmbed();
        if (lbImage) lbImage.style.display = '';
        if (lbContent) lbContent.classList.remove('ig-lightbox__content--video');
      }
      function nextSlide() { openLightbox((lbIndex + 1) % postsData.length); }
      function prevSlide() { openLightbox((lbIndex - 1 + postsData.length) % postsData.length); }

      // Open on click — but not when the click was actually a drag.
      cards.forEach(function(card, idx) {
        var trigger = card.querySelector('[data-lightbox-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          if (dragDist > 8) { dragDist = 0; return; }
          openLightbox(idx);
        });
      });

      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbBackdrop) lbBackdrop.addEventListener('click', closeLightbox);
      if (lbPrev) lbPrev.addEventListener('click', prevSlide);
      if (lbNext) lbNext.addEventListener('click', nextSlide);

      document.addEventListener('keydown', function(e) {
        if (lightbox.getAttribute('aria-hidden') === 'true') return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') prevSlide();
        if (e.key === 'ArrowRight') nextSlide();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var galleries = document.querySelectorAll('[id^="instagram-gallery-"]');

    galleries.forEach(function(section) {
      var lightbox = section.querySelector('.ig-lightbox');
      if (!lightbox) return;

      var items = section.querySelectorAll('.ig-gallery__item');
      var lightboxImage = lightbox.querySelector('.ig-lightbox__image');
      var lightboxCaption = lightbox.querySelector('.ig-lightbox__caption-text');
      var lightboxAuthor = lightbox.querySelector('.ig-lightbox__author-line');
      var lightboxLink = lightbox.querySelector('.ig-lightbox__permalink');
      var lightboxEmbed = lightbox.querySelector('.ig-lightbox__embed');
      var lightboxContent = lightbox.querySelector('.ig-lightbox__content');
      var lightboxVideo = lightbox.querySelector('.ig-lightbox__video');
      var closeBtn = lightbox.querySelector('.ig-lightbox__close');
      var backdrop = lightbox.querySelector('.ig-lightbox__backdrop');
      var prevBtn = lightbox.querySelector('.ig-lightbox__nav--prev');
      var nextBtn = lightbox.querySelector('.ig-lightbox__nav--next');

      var currentLightboxIndex = 0;
      var postsData = [];

      // Parse all post data
      items.forEach(function(item, idx) {
        var dataEl = item.querySelector('.ig-gallery__data');
        if (dataEl) {
          try {
            var data = JSON.parse(dataEl.textContent);
            data._index = idx;
            postsData.push(data);
          } catch (e) {
            console.error('Failed to parse post data:', e);
          }
        }
      });

      function loadInstagramEmbed() {
        if (window.instgrm && window.instgrm.Embeds) {
          window.instgrm.Embeds.process();
        } else if (!document.getElementById('ig-embed-script')) {
          var s = document.createElement('script');
          s.id = 'ig-embed-script';
          s.async = true;
          s.src = 'https://www.instagram.com/embed.js';
          document.body.appendChild(s);
        }
      }

      function clearEmbed() {
        if (lightboxEmbed) {
          lightboxEmbed.innerHTML = '';
          lightboxEmbed.style.display = 'none';
        }
      }

      function clearVideo() {
        if (lightboxVideo) {
          try { lightboxVideo.pause(); } catch (e) {}
          lightboxVideo.onerror = null;
          lightboxVideo.removeAttribute('src');
          if (lightboxVideo.load) lightboxVideo.load();
          lightboxVideo.style.display = 'none';
        }
      }

      function showEmbed(post) {
        if (!lightboxEmbed) return;
        // The IG embed is a self-contained card, so present it alone (no info panel).
        if (lightboxContent) lightboxContent.classList.add('ig-lightbox__content--video');
        clearVideo();
        lightboxImage.onerror = null;
        lightboxImage.style.display = 'none';
        lightboxEmbed.style.display = '';
        lightboxEmbed.innerHTML =
          '<blockquote class="instagram-media" data-instgrm-permalink="' +
          post.permalink + '?utm_source=ig_embed" data-instgrm-version="14" ' +
          'style="margin:0 auto;max-width:100%;width:100%;background:#fff;border-radius:8px;"></blockquote>';
        loadInstagramEmbed();
      }

      // Clean fallback for posts whose photo is gone (old community posts: the IG
      // CDN url expired and, being someone else's post older than IG's 24h window,
      // it can't be re-hosted). Show an on-brand "view on Instagram" panel next to
      // the caption instead of an empty/black box. (The IG embed renders in the
      // grid tile but Instagram won't reliably render a 2nd embed of the same post
      // inside the lightbox, so we don't depend on it here.)
      function showUnavailable(post) {
        if (lightboxContent) lightboxContent.classList.remove('ig-lightbox__content--video');
        clearVideo();
        lightboxImage.style.display = 'none';
        if (lightboxEmbed) {
          lightboxEmbed.style.display = '';
          lightboxEmbed.innerHTML =
            '<div class="ig-lightbox__unavailable">' +
            '<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="2" width="20" height="20" rx="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>' +
            '<p>This photo lives on Instagram</p>' +
            '<a href="' + (post.permalink || '#') + '" target="_blank" rel="noopener noreferrer">View on Instagram →</a>' +
            '</div>';
        }
      }

      function openLightbox(index) {
        if (index < 0 || index >= postsData.length) return;
        currentLightboxIndex = index;
        var post = postsData[index];

        var isVideo = post.mediaType === 'VIDEO' && post.permalink;
        if (isVideo && post.videoUrl && lightboxVideo) {
          // Native inline player inside the SAME two-column card as images, so the
          // video lightbox looks identical to the image one (image-area + info panel).
          if (lightboxContent) lightboxContent.classList.remove('ig-lightbox__content--video');
          clearEmbed();
          lightboxImage.style.display = 'none';
          lightboxVideo.style.display = '';
          lightboxVideo.poster = post.image || '';
          lightboxVideo.muted = true;
          lightboxVideo.src = post.videoUrl;
          lightboxVideo.onerror = function () {
            // Direct CDN URL expired -> fall back to the official Instagram embed.
            showEmbed(post);
          };
          var pp = lightboxVideo.play();
          if (pp && pp.catch) pp.catch(function () {});
        } else if (isVideo) {
          // No direct video URL -> Instagram embed (clean single-column fallback).
          lightboxImage.style.display = 'none';
          showEmbed(post);
        } else if (post.image) {
          if (lightboxContent) lightboxContent.classList.remove('ig-lightbox__content--video');
          clearVideo();
          clearEmbed();
          lightboxImage.style.display = '';
          // If the image URL is dead (e.g. an old post's expired IG CDN link),
          // show a clean "view on Instagram" panel instead of a black box.
          lightboxImage.onerror = function () {
            lightboxImage.onerror = null;
            showUnavailable(post);
          };
          lightboxImage.src = post.image;
          lightboxImage.alt = post.caption || 'Instagram post';
        } else {
          clearEmbed();
          showUnavailable(post);
        }

        lightboxCaption.textContent = post.caption || '';
        lightboxAuthor.textContent = post.author ? ('@' + post.author) : '';
        lightboxLink.href = post.permalink || '#';

        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeLightbox() {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        clearVideo();
        clearEmbed();
        if (lightboxImage) lightboxImage.style.display = '';
        if (lightboxContent) lightboxContent.classList.remove('ig-lightbox__content--video');
      }

      function nextSlide() {
        var next = currentLightboxIndex + 1;
        if (next >= postsData.length) next = 0;
        openLightbox(next);
      }

      function prevSlide() {
        var prev = currentLightboxIndex - 1;
        if (prev < 0) prev = postsData.length - 1;
        openLightbox(prev);
      }

      // Click triggers
      items.forEach(function(item, idx) {
        var trigger = item.querySelector('[data-lightbox-trigger]');
        if (trigger) {
          trigger.addEventListener('click', function() {
            openLightbox(idx);
          });
        }
      });

      // Close
      if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
      if (backdrop) backdrop.addEventListener('click', closeLightbox);

      // Nav
      if (prevBtn) prevBtn.addEventListener('click', prevSlide);
      if (nextBtn) nextBtn.addEventListener('click', nextSlide);

      // Keyboard
      document.addEventListener('keydown', function(e) {
        if (lightbox.getAttribute('aria-hidden') === 'true') return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') prevSlide();
        if (e.key === 'ArrowRight') nextSlide();
      });

      // Touch swipe in lightbox
      var touchStartX = 0;
      lightbox.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].pageX;
      }, { passive: true });

      lightbox.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].pageX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) nextSlide();
          else prevSlide();
        }
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-admin"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var configEl = document.getElementById('ugc-admin-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch(e) {
    console.error('UGC Admin: failed to parse config', e);
    return;
  }

  var ADMIN_PIN = config.adminPin || '';
  var STORE_DOMAIN = config.storeDomain || '';
  var GRAPHQL_URL = 'https://' + STORE_DOMAIN + '/admin/api/2024-01/graphql.json';

  // Token is NEVER in page source - loaded from sessionStorage only
  var ADMIN_TOKEN = '';
  try { ADMIN_TOKEN = sessionStorage.getItem('ugc_admin_token') || ''; } catch(e) {}

  // ── Gate references ────────────────────────────────────────────────────────

  var pinGate      = document.getElementById('ugc-pin-gate');
  var tokenGate    = document.getElementById('ugc-token-gate');
  var adminContent = document.getElementById('ugc-admin-content');

  var pinInput     = document.getElementById('ugc-pin-input');
  var pinSubmit    = document.getElementById('ugc-pin-submit');
  var pinError     = document.getElementById('ugc-pin-error');

  var tokenInput   = document.getElementById('ugc-token-input');
  var tokenSubmit  = document.getElementById('ugc-token-submit');
  var tokenError   = document.getElementById('ugc-token-error');

  var lockBtn = document.getElementById('ugc-lock-btn');

  function showPinGate() {
    if (pinGate)      pinGate.style.display = 'flex';
    if (tokenGate)    tokenGate.style.display = 'none';
    if (adminContent) adminContent.style.display = 'none';
    if (pinInput)     { pinInput.value = ''; pinInput.focus(); }
    if (pinError)     pinError.style.display = 'none';
  }

  function showTokenGate() {
    if (pinGate)      pinGate.style.display = 'none';
    if (tokenGate)    tokenGate.style.display = 'flex';
    if (adminContent) adminContent.style.display = 'none';
    if (tokenInput)   { tokenInput.value = ''; tokenInput.focus(); }
    if (tokenError)   tokenError.style.display = 'none';
  }

  function showAdmin() {
    if (pinGate)      pinGate.style.display = 'none';
    if (tokenGate)    tokenGate.style.display = 'none';
    if (adminContent) adminContent.style.display = 'block';
  }

  function unlock() {
    showAdmin();
    try { sessionStorage.setItem('ugc_unlocked', '1'); } catch(e) {}
  }

  function lock() {
    ADMIN_TOKEN = '';
    try {
      sessionStorage.removeItem('ugc_unlocked');
      sessionStorage.removeItem('ugc_admin_token');
    } catch(e) {}
    showPinGate();
  }

  function checkPin() {
    var entered = (pinInput ? pinInput.value : '').trim();
    if (!ADMIN_PIN || entered === ADMIN_PIN) {
      // PIN passed - check if we already have a token this session
      if (ADMIN_TOKEN) {
        unlock();
      } else {
        showTokenGate();
      }
    } else {
      if (pinError) pinError.style.display = 'block';
      if (pinInput) { pinInput.value = ''; pinInput.focus(); }
    }
  }

  function checkToken() {
    var entered = (tokenInput ? tokenInput.value : '').trim();
    if (!entered) {
      if (tokenError) tokenError.style.display = 'block';
      return;
    }
    ADMIN_TOKEN = entered;
    try { sessionStorage.setItem('ugc_admin_token', ADMIN_TOKEN); } catch(e) {}
    unlock();
  }

  // Auto-unlock flow on page load
  try {
    var alreadyUnlocked = sessionStorage.getItem('ugc_unlocked') === '1';
    if (alreadyUnlocked && ADMIN_TOKEN) {
      showAdmin();
    } else if (alreadyUnlocked && !ADMIN_TOKEN) {
      // PIN passed this session but token expired - re-enter token
      showTokenGate();
    } else if (!ADMIN_PIN) {
      // No PIN required - go straight to token gate (or admin if token exists)
      if (ADMIN_TOKEN) { showAdmin(); } else { showTokenGate(); }
    }
    // else: default - show PIN gate (already shown in HTML)
  } catch(e) {
    if (!ADMIN_PIN) showTokenGate();
  }

  if (pinSubmit)  pinSubmit.addEventListener('click', checkPin);
  if (pinInput) {
    pinInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') checkPin();
    });
  }

  if (tokenSubmit) tokenSubmit.addEventListener('click', checkToken);
  if (tokenInput) {
    tokenInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') checkToken();
    });
  }

  if (lockBtn) lockBtn.addEventListener('click', lock);

  // ── Filters & Reports tab ──────────────────────────────────────────────────

  var filterBtns = document.querySelectorAll('.ugc-admin__filter');
  var cards = document.querySelectorAll('.ugc-admin__card');
  var gridEl = document.getElementById('ugc-grid');
  var reportsEl = document.getElementById('ugc-reports');
  var reportsBuilt = false;

  function applyFilter(filter) {
    filterBtns.forEach(function(btn) {
      btn.classList.toggle('ugc-admin__filter--active', btn.dataset.filter === filter);
    });

    if (filter === 'reports') {
      if (gridEl) gridEl.style.display = 'none';
      if (reportsEl) reportsEl.style.display = 'block';
      if (!reportsBuilt) { buildReports(); reportsBuilt = true; }
      return;
    }

    if (gridEl) gridEl.style.display = '';
    if (reportsEl) reportsEl.style.display = 'none';

    cards.forEach(function(card) {
      var status = card.dataset.status || 'approved';
      var show = filter === 'all' || status === filter;
      card.classList.toggle('ugc-admin__card--hidden', !show);
    });
  }

  filterBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      applyFilter(btn.dataset.filter);
    });
  });

  // ── Reports computation ────────────────────────────────────────────────────

  function buildReports() {
    var pending = 0, approved = 0, rejected = 0, total = 0;
    var authorCounts = {};
    var monthCounts = {};

    cards.forEach(function(card) {
      total++;
      var status = card.dataset.status || 'approved';
      if (status === 'pending') pending++;
      else if (status === 'approved') approved++;
      else if (status === 'rejected') rejected++;

      // Author tally
      var author = (card.dataset.author || '').trim();
      if (author) {
        authorCounts[author] = (authorCounts[author] || 0) + 1;
      }

      // Month tally (parse posted_at)
      var postedAt = (card.dataset.postedAt || card.getAttribute('data-posted-at') || '').trim();
      if (postedAt) {
        var d = new Date(postedAt);
        if (!isNaN(d.getTime())) {
          var key = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
          monthCounts[key] = (monthCounts[key] || 0) + 1;
        }
      }
    });

    // Approval rate
    var rateEl = document.getElementById('rpt-approval-rate');
    var barEl  = document.getElementById('rpt-approval-bar');
    var subEl  = document.getElementById('rpt-approval-sub');
    var reviewedTotal = approved + rejected;
    var rate = reviewedTotal > 0 ? Math.round((approved / reviewedTotal) * 100) : 0;
    if (rateEl) rateEl.textContent = reviewedTotal > 0 ? rate + '%' : 'N/A';
    if (barEl)  barEl.style.width = rate + '%';
    if (subEl)  subEl.textContent = approved + ' approved of ' + reviewedTotal + ' reviewed' + (pending > 0 ? ' (' + pending + ' pending)' : '');

    // Leaderboard
    var lbEl = document.getElementById('rpt-leaderboard');
    if (lbEl) {
      var sorted = Object.keys(authorCounts).sort(function(a, b) {
        return authorCounts[b] - authorCounts[a];
      }).slice(0, 8);

      if (sorted.length === 0) {
        lbEl.innerHTML = '<li class="ugc-report-card__leader-placeholder">No author data yet.</li>';
      } else {
        lbEl.innerHTML = sorted.map(function(author, i) {
          var rank = i + 1;
          var rankClass = rank <= 3 ? ' ugc-report-card__leader-rank--' + rank : '';
          return '<li class="ugc-report-card__leader-item">' +
            '<span class="ugc-report-card__leader-rank' + rankClass + '">' + rank + '</span>' +
            '<span class="ugc-report-card__leader-name">@' + escapeHtml(author) + '</span>' +
            '<span class="ugc-report-card__leader-count">' + authorCounts[author] + ' post' + (authorCounts[author] !== 1 ? 's' : '') + '</span>' +
            '</li>';
        }).join('');
      }
    }

    // Monthly histogram (last 12 months)
    var histEl = document.getElementById('rpt-histogram');
    if (histEl) {
      var now = new Date();
      var months = [];
      for (var m = 11; m >= 0; m--) {
        var d2 = new Date(now.getFullYear(), now.getMonth() - m, 1);
        var k = d2.getFullYear() + '-' + String(d2.getMonth() + 1).padStart(2, '0');
        var label = d2.toLocaleDateString('en-US', { month: 'short' });
        months.push({ key: k, label: label, count: monthCounts[k] || 0 });
      }

      var maxCount = Math.max(1, Math.max.apply(null, months.map(function(m2) { return m2.count; })));
      var hasAnyData = months.some(function(m2) { return m2.count > 0; });

      if (!hasAnyData) {
        histEl.innerHTML = '<p class="ugc-report-card__leader-placeholder">No date data yet - post dates will appear here after syncing.</p>';
      } else {
        histEl.innerHTML = months.map(function(m2) {
          var heightPct = Math.round((m2.count / maxCount) * 100);
          var barH = Math.max(heightPct, m2.count > 0 ? 8 : 2);
          return '<div class="ugc-histogram-bar" style="height:' + barH + '%;" title="' + m2.label + ': ' + m2.count + '">' +
            (m2.count > 0 ? '<span class="ugc-histogram-bar-val">' + m2.count + '</span>' : '') +
            '<span class="ugc-histogram-bar-label">' + m2.label + '</span>' +
            '</div>';
        }).join('');
      }
    }
  }

  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ── Toast ──────────────────────────────────────────────────────────────────

  var toastEl = document.getElementById('ugc-toast');
  var toastTimer = null;

  function showToast(msg, isError) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.remove('ugc-admin__toast--error');
    if (isError) toastEl.classList.add('ugc-admin__toast--error');
    toastEl.classList.add('ugc-admin__toast--visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function() {
      toastEl.classList.remove('ugc-admin__toast--visible');
    }, 3500);
  }

  // ── Stats update ────────────────────────────────────────────────────────────

  function refreshStats() {
    var pending = 0, approved = 0, rejected = 0, total = 0;
    cards.forEach(function(card) {
      total++;
      var s = card.dataset.status || 'approved';
      if (s === 'pending') pending++;
      else if (s === 'approved') approved++;
      else if (s === 'rejected') rejected++;
    });
    var sP = document.getElementById('stat-pending');
    var sA = document.getElementById('stat-approved');
    var sR = document.getElementById('stat-rejected');
    var sT = document.getElementById('stat-total');
    if (sP) sP.textContent = pending;
    if (sA) sA.textContent = approved;
    if (sR) sR.textContent = rejected;
    if (sT) sT.textContent = total;
  }

  // ── Admin API calls ────────────────────────────────────────────────────────

  function adminGraphql(query, variables) {
    if (!ADMIN_TOKEN) {
      return Promise.reject(new Error('No admin token configured. Add it in Theme Editor > UGC Admin settings.'));
    }
    return fetch(GRAPHQL_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Access-Token': ADMIN_TOKEN
      },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function(res) {
      return res.json();
    }).then(function(json) {
      if (json.errors && json.errors.length > 0) {
        throw new Error(json.errors[0].message);
      }
      return json.data;
    });
  }

  function setPostStatus(postId, status, cardEl, btn) {
    btn.disabled = true;
    btn.textContent = '...';

    var mutation = 'mutation metaobjectUpdate($id: ID!, $metaobject: MetaobjectUpdateInput!) { metaobjectUpdate(id: $id, metaobject: $metaobject) { metaobject { id } userErrors { field message } } }';
    var variables = {
      id: postId,
      metaobject: { fields: [{ key: 'status', value: status }] }
    };

    adminGraphql(mutation, variables).then(function(data) {
      var errors = data.metaobjectUpdate && data.metaobjectUpdate.userErrors;
      if (errors && errors.length > 0) {
        throw new Error(errors[0].message);
      }

      // Update card state
      cardEl.dataset.status = status;

      // Update badge
      var badge = cardEl.querySelector('.ugc-admin__badge');
      if (badge) {
        badge.className = 'ugc-admin__badge ugc-admin__badge--' + status;
        badge.textContent = status;
      }

      // Rebuild action buttons
      rebuildCardActions(cardEl, postId, status);

      refreshStats();
      showToast('Post ' + status + ' successfully.');
    }).catch(function(err) {
      btn.disabled = false;
      btn.textContent = status === 'approved' ? 'Approve' : 'Reject';
      showToast('Error: ' + err.message, true);
    });
  }

  function deletePost(postId, cardEl, btn) {
    if (!confirm('Delete this post permanently? This cannot be undone.')) return;
    btn.disabled = true;
    btn.textContent = '...';

    var mutation = 'mutation metaobjectDelete($id: ID!) { metaobjectDelete(id: $id) { deletedId userErrors { field message } } }';
    var variables = { id: postId };

    adminGraphql(mutation, variables).then(function(data) {
      var errors = data.metaobjectDelete && data.metaobjectDelete.userErrors;
      if (errors && errors.length > 0) {
        throw new Error(errors[0].message);
      }

      // Remove card from DOM
      cardEl.style.transition = 'opacity 0.3s, transform 0.3s';
      cardEl.style.opacity = '0';
      cardEl.style.transform = 'scale(0.95)';
      setTimeout(function() {
        cardEl.remove();
        refreshStats();
      }, 320);

      showToast('Post deleted.');
    }).catch(function(err) {
      btn.disabled = false;
      btn.textContent = 'Delete';
      showToast('Error: ' + err.message, true);
    });
  }

  function rebuildCardActions(cardEl, postId, newStatus) {
    var actionsEl = cardEl.querySelector('.ugc-admin__card-actions');
    if (!actionsEl) return;
    actionsEl.innerHTML = '';

    if (newStatus !== 'approved') {
      var approveBtn = makeBtn('Approve', 'approve', postId, cardEl);
      actionsEl.appendChild(approveBtn);
    }
    if (newStatus !== 'rejected') {
      var rejectBtn = makeBtn('Reject', 'reject', postId, cardEl);
      actionsEl.appendChild(rejectBtn);
    }
    var deleteBtn = makeBtn('Delete', 'delete', postId, cardEl);
    actionsEl.appendChild(deleteBtn);

    // Re-apply current filter
    var activeFilter = document.querySelector('.ugc-admin__filter--active');
    if (activeFilter) applyFilter(activeFilter.dataset.filter);
  }

  function makeBtn(label, action, postId, cardEl) {
    var btn = document.createElement('button');
    btn.className = 'ugc-admin__action-btn ugc-admin__action-btn--' + action;
    btn.dataset.action = action;
    btn.textContent = label;
    btn.addEventListener('click', function() {
      handleAction(action, postId, cardEl, btn);
    });
    return btn;
  }

  function handleAction(action, postId, cardEl, btn) {
    if (action === 'approve') {
      setPostStatus(postId, 'approved', cardEl, btn);
    } else if (action === 'reject') {
      setPostStatus(postId, 'rejected', cardEl, btn);
    } else if (action === 'delete') {
      deletePost(postId, cardEl, btn);
    }
  }

  // ── Bind initial action buttons ────────────────────────────────────────────

  document.querySelectorAll('.ugc-admin__action-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var cardId = btn.dataset.card;
      var cardEl = cardId ? document.getElementById(cardId) : btn.closest('.ugc-admin__card');
      var postId = btn.dataset.id || (cardEl && cardEl.dataset.id);
      var action = btn.dataset.action;
      if (cardEl && postId && action) {
        handleAction(action, postId, cardEl, btn);
      }
    });
  });

})();

  } catch(e) { console.error(e); }
})();
})();
